import { onCLS, onFCP, onINP, onLCP, onTTFB } from 'web-vitals'

import { getDeviceInfo } from '@thg-commerce/gravity-system/utils/UserAgent/UserAgent'

const inpThreshold = 300

export const CORE_WEB_VITAL_ACCESSORS = [
  {
    accessor: onFCP,
    field: 'firstContentfulPaint',
  },
  {
    accessor: onLCP,
    field: 'largestContentfulPaint',
  },
  {
    accessor: onCLS,
    field: 'cumulativeLayoutShift',
  },
  {
    accessor: onTTFB,
    field: 'timeToFirstByte',
  },
  {
    accessor: (callback) => {
      onINP(
        (metric) => {
          callback(metric)

          if (Math.floor(Math.random() * 101) > 20) {
            return
          }
          try {
            if (metric.value > inpThreshold && metric?.entries?.length) {
              const entry = metric.entries[0]
              const deviceType = getDeviceInfo(window.navigator.userAgent)

              if (entry.target) {
                const target = entry.target as HTMLElement

                const elementData = {
                  deviceType,
                  url: window.location.href,
                  tagName: target.tagName?.toLowerCase(),
                  id: target.id || undefined,
                  testId: target.getAttribute('data-testid') || undefined,
                  inp: Math.round(metric.value),
                  ['aria-label']:
                    target.getAttribute('aria-label') || undefined,
                  interactionType: entry.name || 'unknown',
                }

                if (!window.__inpElements) window.__inpElements = []
                window.__inpElements.push(elementData)

                if (window.__inpElements.length > 3) {
                  window.__inpElements = window.__inpElements
                    .sort((a, b) => b.inp - a.inp)
                    .slice(0, 3)
                }
              }
            }
          } catch (err) {}
        },
        { reportAllChanges: true },
      )
    },
    field: 'interactionToNextPaint',
  },
]
